import type { Address } from '@hoodmorning/contracts';
import { robinhoodChain } from '@hoodmorning/config';
import { getAddress } from 'viem';

export function validateRecoveryRpcUrl(value: string): string {
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    throw new Error('RPC URL is invalid');
  }
  if (url.username !== '' || url.password !== '') {
    throw new Error('RPC URL must not contain embedded credentials');
  }
  const localHttp =
    url.protocol === 'http:' &&
    (url.hostname === 'localhost' || url.hostname === '127.0.0.1' || url.hostname === '[::1]');
  if (url.protocol !== 'https:' && !localHttp) {
    throw new Error('RPC URL must use HTTPS (local loopback HTTP is allowed for offline use)');
  }
  return url.toString();
}

export function assertFreshWalletContext(input: {
  expectedOwner: Address;
  currentOwner: Address | undefined;
  chainId: number;
}): void {
  if (input.currentOwner === undefined || getAddress(input.currentOwner) !== getAddress(input.expectedOwner)) {
    throw new Error('Submission locked: the wallet account changed; reconnect and verify again.');
  }
  if (input.chainId !== robinhoodChain.id) {
    throw new Error(`Submission locked: owner wallet is not on Robinhood Chain ${robinhoodChain.id}.`);
  }
}
